import { encryptData, decryptData } from "./securityService"

let base = "/api"
if (process.env.REACT_APP_API_URL) {
  base = process.env.REACT_APP_API_URL
}
const frontKey = localStorage.getItem('frontKey')

async function post(url: any, key: string | null, data: any = {}) {
  data.origin = globalThis.location.protocol + '//' + globalThis.location.host + globalThis.location.pathname
  const bodyData = key ? await encryptData(data, key) : { data: { origin: data.origin }, key: frontKey }
  const config: RequestInit = {
    method: 'POST',
    body: JSON.stringify(bodyData),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    }
  }
  const res = await fetch(base + url, config)
  if (res.status === 240) {
    throw { status: 240, message: "Token Expired" }
  }
  const encryptedData = await res.json();
  let result: any;
  if (!encryptedData.key) {
    result = encryptedData;
  } else {
    result = await decryptData(encryptedData);
  }

  if (!res.ok || (result && typeof result === 'object' && result.status >= 400)) {
    if (result && typeof result === 'object' && (result.redirect || result.status === 401 || result.status === 403)) {
      return result;
    }
    const errorMsg = result?.message || `Error ${res.status}: Operación no autorizada o fallida`;
    const errObj: any = new Error(errorMsg);
    errObj.status = result?.status || res.status;
    errObj.data = result;
    throw errObj;
  }

  return result;
}

const fetchDataService = { post }
export default fetchDataService
